
import lvl2 from '../assets/ui/fantasy/2lvl.png'
import lvl3 from '../assets/ui/fantasy/3lvl.png'
import lvl4 from '../assets/ui/fantasy/4lvl.png'
import lvl5 from '../assets/ui/fantasy/5lvl.png'
import lvl6 from '../assets/ui/fantasy/6lvl.png'
import lvl7 from '../assets/ui/fantasy/7lvl.png'
import lvl8 from '../assets/ui/fantasy/8lvl.png'
import lvl9 from '../assets/ui/fantasy/9lvl.png'
import lvl10 from '../assets/ui/fantasy/10lvl.png'
import lvl11 from '../assets/ui/fantasy/11lvl.png'

export interface AchievementReward {
    level: number;
    title: string;
    description: string;
    assetUrl: string;
    isMajor?: boolean; // For larger nodes/visuals
    emoteId?: string; // ID from EMOTES for unlock logic
}

export const ACHIEVEMENT_REWARDS: AchievementReward[] = [
    {
        level: 2,
        title: "Novice's Supply",
        description: "A starter pack for the journey ahead.",
        assetUrl: lvl2,
        emoteId: 'THANKS'
    },
    {
        level: 3,
        title: "Scout's Bounty",
        description: "Resources gathered from the outskirts.",
        assetUrl: lvl3,
        emoteId: 'SMIRK'
    },
    {
        level: 4,
        title: "Warrior's Cache",
        description: "Better gear for tougher battles.",
        assetUrl: lvl4,
        isMajor: true,
        emoteId: 'SHOCKED'
    },
    // Skipped 5
    {
        level: 6,
        title: "Captain's Chest",
        description: "Gold and glory await.",
        assetUrl: lvl6,
        isMajor: true,
        emoteId: 'SAD'
    },
    // Skipped 7
    {
        level: 8,
        title: "Epic Loot",
        description: "Only the brave deserve this.",
        assetUrl: lvl8,
        isMajor: true,
        emoteId: 'PIECE'
    },
    // Skipped 9, 10
    {
        level: 11,
        title: "Arcane Mastery",
        description: "The ultimate status symbol.",
        assetUrl: lvl11,
        isMajor: true,
        emoteId: 'ANGER'
    },
]
